import { useQuery } from "@apollo/client";

import { gql } from "../../../generated-graphql";

/**
 * Counts the "active customer" tenants — non-disabled and non-demo. This
 * is the staff working definition of "real customer" and is used as the
 * denominator for adoption percentages on the Feature Flags page.
 *
 * Wrapped in a hook so the FlagsTab and the per-flag drawer share a
 * stable cache entry instead of issuing the same query twice.
 *
 * NOTE: We ask for `items { id }` even though we only need `count`. The
 * `tenants` resolver derives its Prisma `select` from the requested
 * GraphQL items fields — asking only for `count` results in an empty
 * `select` that Prisma rejects (`Unknown field at " selection"`).
 * `pageSize: 1` keeps the items payload tiny.
 */
const CUSTOMER_TENANT_COUNT_QUERY = gql(`
  query CustomerTenantCount {
    tenants(search: "isDisabled:false isDemo:false", pageSize: 1) {
      count
      items {
        id
      }
    }
  }
`);

export function useCustomerTenantCount(): { count: number; loading: boolean } {
  const { data, loading } = useQuery(CUSTOMER_TENANT_COUNT_QUERY, {
    fetchPolicy: "cache-first",
  });
  return {
    count: data?.tenants.count ?? 0,
    loading,
  };
}
